/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LoginRequestEx as UserServiceContractLoginRequestEx } from '../models/UserService/Contract/login-request-ex';
import { LoginResponse as UserServiceContractLoginResponse } from '../models/UserService/Contract/login-response';

@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiLoginCheckLoginPost
   */
  static readonly ApiLoginCheckLoginPostPath = '/api/Login/CheckLogin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginCheckLoginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Plain$Response(params?: {
    lang?: string;
    body?: UserServiceContractLoginRequestEx
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoginService.ApiLoginCheckLoginPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserServiceContractLoginResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginCheckLoginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Plain(params?: {
    lang?: string;
    body?: UserServiceContractLoginRequestEx
  },
  context?: HttpContext

): Observable<UserServiceContractLoginResponse> {

    return this.apiLoginCheckLoginPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>) => r.body as UserServiceContractLoginResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginCheckLoginPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Response(params?: {
    lang?: string;
    body?: UserServiceContractLoginRequestEx
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoginService.ApiLoginCheckLoginPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserServiceContractLoginResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginCheckLoginPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost(params?: {
    lang?: string;
    body?: UserServiceContractLoginRequestEx
  },
  context?: HttpContext

): Observable<UserServiceContractLoginResponse> {

    return this.apiLoginCheckLoginPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>) => r.body as UserServiceContractLoginResponse)
    );
  }

  /**
   * Path part for operation apiLoginLogoutGet
   */
  static readonly ApiLoginLogoutGetPath = '/api/Login/Logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginLogoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginLogoutGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, LoginService.ApiLoginLogoutGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginLogoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginLogoutGet(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.apiLoginLogoutGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiLoginGetUserDataGet
   */
  static readonly ApiLoginGetUserDataGetPath = '/api/Login/GetUserData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginGetUserDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoginService.ApiLoginGetUserDataGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserServiceContractLoginResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginGetUserDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<UserServiceContractLoginResponse> {

    return this.apiLoginGetUserDataGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>) => r.body as UserServiceContractLoginResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginGetUserDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoginService.ApiLoginGetUserDataGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserServiceContractLoginResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginGetUserDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet(params?: {
  },
  context?: HttpContext

): Observable<UserServiceContractLoginResponse> {

    return this.apiLoginGetUserDataGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>) => r.body as UserServiceContractLoginResponse)
    );
  }

}
